<div class="container">
  <div class="row g-0">
    <div class="col-12 d-flex flex-column justify-content-center">
      <div [align]="'center'" class="title" *ngIf="data.title">
        <app-h4 >{{ data.title }}</app-h4>
      </div>
      <ng-container *ngIf="!data.hasOwnProperty('contentComponent')">
        <div class="align-center">
          <!-- align left within a centrally aligned block to cater for multi-line messages.
            The left alignment will not be noticed for a single line message -->
          <div [align]="'left'">
            <app-content [ngClass]="{ 'align-text-center': asMessageData(data).messageTextAlignment }">
              <app-body *ngIf="asMessageData(data).messageFontSize === 'large'">{{ asMessageData(data).message }}</app-body>
              <app-p *ngIf="asMessageData(data).messageFontSize === 'small'">{{ asMessageData(data).message }}</app-p>
            </app-content>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="data.hasOwnProperty('contentComponent')">
        <ndc-dynamic [ndcDynamicComponent]="asComponentData(data).contentComponent"></ndc-dynamic>
      </ng-container>
    </div>
  </div>

  <div class="row g-0">
    <div class="col-6">
      <app-button data-tid-no-button theme="secondary-action" (click)="onNoClick()">{{ data.refuteText }}</app-button>
    </div>
    <div class="col-6 d-flex justify-content-end">
      <app-button
        data-tid-yes-button
        [theme]="'primary-action'"
        matDialogClose="CONFIRMED"
        [focussed]="true"
        >{{ data.confirmText }}</app-button
      >
    </div>
  </div>
</div>
